import xhr from 'xhr';

/**
 * Documentos del área para la Ventanilla (admin › Ventanilla › Configuración y documentos). Endpoints
 * en klazia-api: src/api/ventanilla/routes/documents.js. Marcar una versión lista para revisión
 * guarda una copia y no cambia nada en el agente.
 */

export const VERSION_STATUS = {
  base: { label: 'Versión de partida', tone: 'gray' },
  lista_para_revision: { label: 'Lista para revisión', tone: 'blue' },
  analizada: { label: 'Analizada', tone: 'blue' },
  en_revision: { label: 'En revisión', tone: 'purple' },
  requiere_guion: { label: 'Requiere ajuste en el guion', tone: 'orange' },
  requiere_codigo: { label: 'Requiere código', tone: 'orange' },
  lista_para_activar: { label: 'Lista para activar', tone: 'purple' },
  reemplazada: { label: 'Reemplazada', tone: 'gray' },
  descartada: { label: 'Descartada', tone: 'gray' },
};

/** Estado de Drive frente a la versión activa y la que está en revisión. */
export const DRIVE_STATE = {
  sin_cambios: { label: 'Sin cambios', tone: 'green', text: 'Drive es igual a la versión activa.' },
  cambios_sin_marcar: {
    label: 'Cambios sin marcar',
    tone: 'orange',
    text: 'Hay cambios en Drive desde la versión activa. Cuando termines de editar, márcala lista para revisión.',
  },
  igual_a_revision: { label: 'En revisión', tone: 'blue', text: 'Drive es igual a la versión que está en revisión.' },
  cambios_despues_de_revision: {
    label: 'Cambios nuevos',
    tone: 'orange',
    text: 'Hay cambios en Drive después de la versión en revisión. Puedes terminar de revisar esa versión o marcar una nueva, que la reemplaza.',
  },
  sin_revisar: { label: 'Sin revisar', tone: 'gray', text: 'Todavía no se ha consultado Drive.' },
  error: { label: 'Error al leer Drive', tone: 'red', text: null },
};

export async function listDocuments() {
  const { data } = await xhr.get('/ventanilla-docs');
  return data;
}

export async function checkDocument(key) {
  const { data } = await xhr.post(`/ventanilla-docs/${key}/check`);
  return data;
}

export async function markReady(key, note) {
  const { data } = await xhr.post(`/ventanilla-docs/${key}/mark-ready`, { note });
  return data;
}

export async function getVersion(id) {
  const { data } = await xhr.get(`/ventanilla-docs/versions/${id}`);
  return data;
}

export async function discardVersion(id, note) {
  const { data } = await xhr.post(`/ventanilla-docs/versions/${id}/discard`, { note });
  return data;
}

/** Mensaje de error de la API (Strapi responde { error: { message } }). */
export const apiError = (err, fallback = 'No se pudo completar la acción.') =>
  err?.response?.data?.error?.message || err?.message || fallback;
